import coverApi from '@/services/CoverApi'
import dayjs from 'dayjs'

export default {
  namespaced: true,
  state: {
    covers: [],
    paginationData: {
      descending: true,
      page: 1,
      rowsPerPage: 5,
      sortBy: 'id',
      totalItems: 0,
      rowsPerPageItems: [5]
    },
    companyId: '',
    loading: true
  },
  mutations: {
    setPagination (state, paginationData) {
      state.paginationData = paginationData
    },
    setCoversActivated (state, covers) {
      state.covers = covers
    },
    setCoversActivatedTotalItems (state, totalItems) {
      state.paginationData.totalItems = totalItems
    },
    changeLoadingState (state, loading) {
      state.loading = loading
    },
    setCoversCompanies (state, { companies }) {
      state.covers.forEach(function (cover) {
        cover.seller = companies.find(function (company) {
          return company.id === cover.sellerId
        })

        cover.buyer = companies.find(function (company) {
          return company.id === cover.buyerId
        })
      })
    },
    setCompanyId (state, companyId) {
      state.companyId = companyId
    }
  },
  actions: {
    getCoversActivated (context, filters) {
      let companyId = !!filters ? filters.companyId : undefined
      let coverId = !!filters ? filters.coverId : undefined
      context.commit('changeLoadingState', true)
      return coverApi.fetchCoversbyStatusPerPage(context.state.paginationData.page, context.state.paginationData.rowsPerPage, 'Activated', 'quotedAt', null, null, 'activatedAt', 'desc', companyId, coverId)
        .then((result) => {
          if (result) {
            let emptyCompany = {
              id: '',
              name: '',
              identifierType: '',
              identifierValue: ''
            }
            let covers = result.items.map((item) => {
              return {
                id: item.id,
                sellerId: item.sellerId,
                buyerId: item.buyerId,
                dueAt: item.invoice.dueAt,
                amount: item.invoice.amount + ' ' + item.invoice.currency.toUpperCase(),
                currency: item.invoice.currency.toUpperCase(),
                number: item.invoice.number,
                coverDate: item.coverage.activatedAt,
                coverPrice: item.coverage.coverPrice !== undefined ? item.coverage.coverPrice + ' ' + item.coverage.currency.toUpperCase() : '',
                islate: dayjs().startOf('day').isAfter(dayjs(item.claimLimitAt).add(-6, 'days')),
                isDueDatePassed: dayjs().startOf('day').isAfter(item.invoice.dueAt),
                daysLate: dayjs(new Date()).diff(dayjs(item.invoice.dueAt).add(1, 'days'), 'days'),
                claimLimitAt: item.claimLimitAt,
                canbeclaimed: true,
                seller: emptyCompany,
                buyer: emptyCompany
              }
            })
            let totalItems = result.totalCount
            context.commit('setCoversActivated', covers)
            context.commit('setCoversActivatedTotalItems', totalItems)
            if (totalItems > 0) {
              let sellerIds = covers.map((item) => {
                return item.sellerId
              })
              let buyerIds = covers.map((item) => {
                return item.buyerId
              })
              let companieIds = [...new Set(sellerIds.concat(buyerIds))]
              context.dispatch('getCoverCompanies', companieIds).then(() => {
                context.commit('changeLoadingState', false)
              })
            } else {
              context.commit('changeLoadingState', false)
            }
          }
        }).catch((err) => {
          console.log(err)
        })
    },
    getCoverCompanies (context, companieIds) {
      return coverApi.fetchMappedCompaniesFromId(companieIds).then((companies) => {
        context.commit('setCoversCompanies', { companies })
      }).catch((err) => {
        console.log(err)
      })
    },
    setPagination (context, paginationData) {
      context.commit('setPagination', paginationData)
    },
    setCoversCompanies (context, companies) {
      context.commit('setCoversCompanies', { companies })
    },
    startLoadCovers (context) {
      context.commit('changeLoadingState', true)
    },
    setCompanyId (context, companyId) {
      context.commit('setCompanyId', companyId)
    },
    getEmptyCovers (context) {
      context.commit('setCoversActivated', [])
      context.commit('setCoversActivatedTotalItems', 0)
      context.commit('changeLoadingState', false)
    }
  }
}
